module.exports = __webpack_public_path__ + "static/media/happy-01.71e13008.svg";